export default __webpack_public_path__ + "static/gamePreview-3081c6f89d66043d28d05efdefab5ce3.png";